"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createInitialState = exports.configureChatSDKCallbacks = void 0;
var _redux = require("redux");
var _middlewares = _interopRequireDefault(require("./middlewares"));
var _reducers = _interopRequireDefault(require("../reducers"));
var _actions = require("../actions");
var _linking = require("../helpers/linking");
var _abTestsUtil = require("../helpers/abTestsUtil");
var _isSsr = require("../helpers/isSsr");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var getVariant = function getVariant() {
  var _window;
  if ((0, _isSsr.isSsr)()) return {};
  var cookie = (_window = window) === null || _window === void 0 || (_window = _window.document) === null || _window === void 0 ? void 0 : _window.cookie;
  if (!cookie) return {};
  return (0, _abTestsUtil.getABListForWeb)(cookie);
};
var createInitialState = exports.createInitialState = function createInitialState(_ref) {
  var user = _ref.user,
    token = _ref.token,
    _ref$listId = _ref.listId,
    listId = _ref$listId === void 0 ? null : _ref$listId,
    _ref$roomname = _ref.roomname,
    roomname = _ref$roomname === void 0 ? null : _ref$roomname,
    _ref$roomName = _ref.roomName,
    roomName = _ref$roomName === void 0 ? null : _ref$roomName,
    _ref$initialMessage = _ref.initialMessage,
    initialMessage = _ref$initialMessage === void 0 ? undefined : _ref$initialMessage,
    _ref$sendInitialMessa = _ref.sendInitialMessageDirectly,
    sendInitialMessageDirectly = _ref$sendInitialMessa === void 0 ? false : _ref$sendInitialMessa,
    imageUrlFormat = _ref.imageUrlFormat,
    loginUrl = _ref.loginUrl,
    isAutoOpen = _ref.isAutoOpen,
    _ref$initialState = _ref.initialState,
    initialState = _ref$initialState === void 0 ? {} : _ref$initialState;
  return _objectSpread(_objectSpread({}, initialState), {}, {
    variants: getVariant(),
    renderProps: {
      user: user,
      token: token,
      listId: listId,
      roomname: roomname,
      roomName: roomName,
      initialMessage: initialMessage,
      sendInitialMessageDirectly: sendInitialMessageDirectly,
      imageUrlFormat: imageUrlFormat,
      loginUrl: loginUrl,
      isAutoOpen: isAutoOpen
    }
  });
};
var configureChatSDKCallbacks = exports.configureChatSDKCallbacks = function configureChatSDKCallbacks(store) {
  store.dispatch(function (dispatch, _, _ref2) {
    var ChatSDK = _ref2.ChatSDK;
    if (!ChatSDK) return;
    ChatSDK.onReceiveMessages(function (messages) {
      return dispatch((0, _actions.receiveMessages)(messages));
    });
    ChatSDK.onReceiveChats(function (chats) {
      return dispatch((0, _actions.receiveChats)(chats));
    });
    ChatSDK.onReceiveStatus(function (status) {
      return dispatch((0, _actions.receiveStatus)(status));
    });
    ChatSDK.onError(function (err) {
      return dispatch((0, _actions.handleError)(err));
    });
    ChatSDK.onProfileValidation(function (url) {
      return (0, _linking.openProfileValidationLink)(url);
    });
  });
};
var configureStore = function configureStore(props) {
  var state = createInitialState(props);
  var store = (0, _redux.createStore)(_reducers["default"], state, (0, _middlewares["default"])(props));
  configureChatSDKCallbacks(store);
  return store;
};
var _default = exports["default"] = configureStore;